import {
  REQUEST_FORM_DATA,
  RECEIVE_FORM_DATA,
  RECEIVE_ERROR_FORM_DATA
} from "../actions/formData";

export default function formDataReducer(
  state = { formData: undefined },
  action
) {
  switch (action.type) {
    case REQUEST_FORM_DATA:
      return { ...state, redirecting: true };
    case RECEIVE_FORM_DATA:
      return {
        ...state,
        formData: action.formData
      };
    case RECEIVE_ERROR_FORM_DATA:
      return { ...state, error: action.message };
    default:
      return state;
  }
}
